import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DateFunctions } from "common/datefunctions";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { CUSTOMER_APIs } from "apihandlers/customer";
import AutoComplete from "components/Custom/AutoComplete";
import { GEO_APIs } from "apihandlers/geography";

const TargetDistribution = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [states, setStates] = useState([]);

  const stateRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getStates();
    }
  }, [loading]);

  const getStates = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        setStates(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getCustSalesTypes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "fromDate",
      name: LABELS.FROM_DATE,
      width: "7%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "toDate",
      name: LABELS.TO_DATE,
      width: "7%",
      type: "date",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "state",
      name: LABELS.STATE,
      width: "16%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },

    {
      key: "growthInSales",
      name: LABELS.GROWTH_IN_SALES_PERCENTAGE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "newDealerOpening",
      name: LABELS.NEW_DEALER_OPENING_PERCENTAGE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "dealerManagement",
      name: LABELS.DEALER_MANAGEMENT_PERCENTAGE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "peopleManagement",
      name: LABELS.PEOPLE_MANAGEMENT_PERCENTAGE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "otherAreas",
      name: LABELS.OTHER_AREAS_PERCENTAGE,
      width: "12%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  //   const onchange=()=>{
  //     const value=
  //   }

  const manageDealerManagement = () => {
    const fromDate = (document.getElementById("fromDate") as HTMLInputElement)
      .value;
    const toDate = (document.getElementById("toDate") as HTMLInputElement)
      .value;
    const state = stateRef.current.selectedValue.id;
    const growthInSalesPercentage = (
      document.getElementById("growthInSales") as HTMLInputElement
    ).value;
    const newDealerOpeningPercentage = (
      document.getElementById("newDealerOpening") as HTMLInputElement
    ).value;
    const dealerManagementPercentage = (
      document.getElementById("dealerManagement") as HTMLInputElement
    ).value;

    const peopleManagementPercentage = (
      document.getElementById("peopleManagement") as HTMLInputElement
    ).value;
    const otherAreasPercentage = (
      document.getElementById("peopleManagement") as HTMLInputElement
    ).value;

    // Validations
    let errors = [];
    if (fromDate === "") {
      errors.push({
        id: "fromDate",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDate === "") {
      errors.push({
        id: "toDate",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!state) {
      errors.push({
        id: "state",
        msg:
          "<span class='bold'>" +
          LABELS.STATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!growthInSalesPercentage) {
      errors.push({
        id: "timelyReplacement",
        msg:
          "<span class='bold'>" +
          LABELS.GROWTH_IN_SALES_PERCENTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!newDealerOpeningPercentage) {
      errors.push({
        id: "growthPerReplaced",
        msg:
          "<span class='bold'>" +
          LABELS.NEW_DEALER_OPENING_PERCENTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!dealerManagementPercentage) {
      errors.push({
        id: "smoothDealerClosing",
        msg:
          "<span class='bold'>" +
          LABELS.DEALER_MANAGEMENT_PERCENTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!peopleManagementPercentage) {
      errors.push({
        id: "dealerRoi",
        msg:
          "<span class='bold'>" +
          LABELS.PEOPLE_MANAGEMENT_PERCENTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!otherAreasPercentage) {
      errors.push({
        id: "dealerRoi",
        msg:
          "<span class='bold'>" +
          LABELS.OTHER_AREAS_PERCENTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (
      Number(growthInSalesPercentage) < 0 ||
      Number(growthInSalesPercentage) > 100
    ) {
      errors.push({
        id: "teamAttrition",
        msg:
          "<span class='bold'>" +
          LABELS.GROWTH_IN_SALES_PERCENTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }
    if (
      Number(newDealerOpeningPercentage) < 0 ||
      Number(newDealerOpeningPercentage) > 100
    ) {
      errors.push({
        id: "teamAttrition",
        msg:
          "<span class='bold'>" +
          LABELS.NEW_DEALER_OPENING_PERCENTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }
    if (
      Number(dealerManagementPercentage) < 0 ||
      Number(dealerManagementPercentage) > 100
    ) {
      errors.push({
        id: "teamAttrition",
        msg:
          "<span class='bold'>" +
          LABELS.DEALER_MANAGEMENT_PERCENTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }
    if (
      Number(peopleManagementPercentage) < 0 ||
      Number(peopleManagementPercentage) > 100
    ) {
      errors.push({
        id: "teamAttrition",
        msg:
          "<span class='bold'>" +
          LABELS.PEOPLE_MANAGEMENT_PERCENTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }

    if (
      Number(otherAreasPercentage) < 0 ||
      Number(otherAreasPercentage) > 100
    ) {
      errors.push({
        id: "teamAttrition",
        msg:
          "<span class='bold'>" +
          LABELS.OTHER_AREAS_PERCENTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      fromDate,
      toDate,
      state,
      growthInSalesPercentage,
      newDealerOpeningPercentage,
      dealerManagementPercentage,
      peopleManagementPercentage,
      otherAreasPercentage,

      //activeStatus,
    };
    console.log("args", args);

    setIsSubmit(true);

    setSelectedRow({});
    setManageDialog(false);
    reloadGrid();

    //TODO API still in progress
    //     CUSTOMER_APIs.manageCustSalesType(args).then((res) => {
    //       setIsSubmit(false);
    //       if (res.status === 200) {
    //         COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //         setSelectedRow({});
    //         setManageDialog(false);
    //         reloadGrid();
    //       } else {
    //         COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //       }
    //     });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TARGET_DISTRIBUTION}</li>
        </ul>
        <h4>{TITLES.TARGET_DISTRIBUTION}</h4>
        <p>{SUB_TITLES.TARGET_DISTRIBUTION}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TARGET_DISTRIBUTION}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " +
                LABELS.TARGET_DISTRIBUTION +
                ": " +
                selectedRow.salesType
              : "Add New " + LABELS.TARGET_DISTRIBUTION
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.FROM_DATE}
          </label>
          <TxtRow
            type={"date"}
            id="fromDate"
            defaultValue={DateFunctions.getDate("today", "from", "YYYY-MM-DD")}
          />
          <label
            style={{
              fontWeight: "500",
              fontSize: 14,
              marginTop: 6,
              marginRight: 8,
            }}
          >
            {LABELS.TO_DATE}
          </label>
          <TxtRow
            type={"date"}
            id="toDate"
            defaultValue={DateFunctions.getDate(
              "thismonth",
              "to",
              "YYYY-MM-DD"
            )}
          />
          <div className="formGroup  ">
            <label>{LABELS.STATE}</label>
            {/* {<span className="red">{" *"}</span>} */}
            <AutoComplete
              list={states}
              childRef={stateRef}
              defaultValue={
                selectedRow.dealerId
                  ? {
                      id: selectedRow.dealerId,
                      label: selectedRow.dealerName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              //   disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <TxtRow
              id={"growthInSales"}
              type={"number"}
              label={LABELS.GROWTH_IN_SALES_PERCENTAGE}
              //required={true}
              defaultValue={selectedRow.growthInSales}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"newDealerOpening"}
              type={"number"}
              label={LABELS.NEW_DEALER_OPENING_PERCENTAGE}
              //required={true}
              defaultValue={selectedRow.newDealerOpening}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"dealerManagement"}
              type={"number"}
              label={LABELS.DEALER_MANAGEMENT_PERCENTAGE}
              // required={true}
              defaultValue={selectedRow.dealerManagement}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"peopleManagement"}
              type={"number"}
              label={LABELS.PEOPLE_MANAGEMENT_PERCENTAGE}
              //required={true}
              defaultValue={selectedRow.peopleManagement}
              //   disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"otherAreas"}
              type={"number"}
              label={LABELS.OTHER_AREAS_PERCENTAGE}
              // required={true}
              defaultValue={selectedRow.otherAreas}
              //   disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div>
            <Btn
              text={LABELS.SAVE}
              //   loading={isSubmit}
              onClick={manageDealerManagement}
              bgColor={COLORS.SAVE_GREEN}
            />
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(TargetDistribution);
